/* eslint-disable react/jsx-no-undef */
/* eslint-disable no-console */
/* eslint-disable react/jsx-no-constructed-context-values */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-use-before-define */
/* eslint-disable react/void-dom-elements-no-children */

// eslint-disable-next-line no-use-before-define
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import { setError, setUser } from "./errorHandler";
import ActivationPage from "./app/features/activationPage/pages/activationPage";
import Signin from "./app/features/authentication/pages/signin";
import Signup from "./app/features/authentication/pages/signup";
import NotAuthorized from "./app/features/authentication/pages/notAuthorized";
import { DetailsTenant } from "./app/features/detailsTenant/pages/detailsTenant";
import TenantList from "./app/features/tenantList/pages/tenantList";
import Modal from "./app/shared/components/modal/modal";
import Dashboard from "./app/features/Private/Pages/dashboard";
import ProductList from "./app/features/ProductList/productList";
import MainContainer from "./app/features/flowbiteExample/mainContainer";
import { getProductListRequest } from "./app/store/product/action";
import Createproduct from "./app/features/authentication/pages/createproduct";
import CheckoutPage from "./app/features/checkoutPage/checkoutPage";
import SuccessPage from "./app/features/checkoutPage/successPage";
import CancelPage from "./app/features/checkoutPage/cancelPage";
import DetailProduct from "./app/features/ProductList/detailProduct";
import { MultiDetailsTenant } from "./app/features/multiDetailsTenant/pages/multiDetailsTenant";
import { MultiDetailsTenant2 } from "./app/features/multiDetailsTenant/pages/multiDetailsTenant2";
import SignupUser from "./app/features/authentication/pages/signupUser";
import AccountRecovery from "./app/features/authentication/pages/accountRecovery";
import { UserProfile } from "./app/features/userProfile/pages/userProfile";
import UserList from "./app/features/userList/pages/userList";
import ProductsListV2 from "./app/features/ProductList/productsListV2";
import ProductsListV3 from "./app/features/ProductList/productsListV3";
import DetailsProductV2Nexbot from "./app/features/ProductList/detailsProductV2Nexbot";
import DetailsProductsV2Nexcode from "./app/features/ProductList/detailsProductsV2Nexcode";
import UpgradeTierPage from "./app/features/ProductList/upgradeTier";
import DetailProductV3 from "./app/features/ProductList/detailProductV3";
import ContactPage from "./app/features/contact/ContactPage";
import AdminMonitoring from "./app/features/admin/admin-monitoring";
import MonitorSubscription from "./app/features/admin/monitorSubscription";
import ClientDetail from "./app/features/admin/clientDetail";
const ActivationWrapper = () => {
  const params = useParams();
  return <ActivationPage token={params} />;
};

// eslint-disable-next-line consistent-return
const WrapperComponent = ({ componentName, productList }) => {
  // search params in path
  const searchLoc = useLocation().search;
  const product = new URLSearchParams(searchLoc).get("appCode") ?? "";
  const tenantId =
    new URLSearchParams(searchLoc).get("tenantId") ??
    window.localStorage.getItem("tenantId") ??
    "";

  // set token in session storage
  const token = window.localStorage.getItem("token") ?? "";
  // easily navigate between pages
  const loc = useNavigate();

  switch (componentName) {
    case "signin": {
      return <Signin location={loc} product={product} productList={productList} />;
    }
    case "signup": {
      if (window.localStorage.getItem("role") === "0") {
        return <Signup location={loc} productList={productList} />;
      }
      return <Navigate to="/" />;
    }
    case "signupUser": {
      return <SignupUser location={loc} />;
    }
    case "accountRecovery": {
      return <AccountRecovery location={loc} />;
    }
    case "createproduct": {
      if (window.localStorage.getItem("role") === "0") {
        return <Createproduct location={loc} />;
      }
      return <Navigate to="/" />;
    }
    case "activationWrapper": {
      return <ActivationWrapper location={loc} />;
    }
    case "helpPage": {
      return <HelpPage location={loc} />;
    }
    case "contactPage": {
      return <ContactPage location={loc} />;
    }
    case "detailstenant": {
      // verify if token and tenantId exists in session
      if (tenantId !== "" && token !== "") {
        return (
          <DetailsTenant tenantId={tenantId} location={loc} productList={productList} />
        );
      }
      return <NotAuthorized />;
      /* return <Navigate to='/' />; */
    }
    case "multidetailstenant": {
      // verify if token and tenantId exists in session
      if (tenantId !== "" && token !== "") {
        return (
          <MultiDetailsTenant2 tenantId={tenantId} location={loc} productList={productList} />
        );
      }
      return <NotAuthorized />;
      /* return <Navigate to='/' />; */
    }
    case "userProfile": {
      // verify if token and tenantId exists in session
      if (tenantId !== "" && token !== "") {
        return (
          <UserProfile tenantId={tenantId} location={loc} productList={productList} />
        );
      }
      return <NotAuthorized />;
      /* return <Navigate to='/' />; */
    }
    case "tenantlist": {
      // extract token from session
      const tokenSession = window.localStorage.getItem("token");
      if (!!tokenSession ?? tokenSession.length > 32) {
        return <TenantList location={loc} productList={productList} />;
      }
      return <NotAuthorized />;
    }
    case "userlist": {
      // extract token from session
      const tokenSession = window.localStorage.getItem("token");
      if (!!tokenSession ?? tokenSession.length > 32) {
        return <UserList location={loc} productList={productList} />;
      }
      return <NotAuthorized />;
    }
    case "admin-monitoring": {
      // extract token from session
      const tokenSession = window.localStorage.getItem("token");
      if (!!tokenSession ?? tokenSession.length > 32) {
        return <AdminMonitoring location={loc} />;
      }
      return <NotAuthorized />;
    }
    case "monitorSubscription": {
      // extract token from session
      const tokenSession = window.localStorage.getItem("token");
      if (!!tokenSession ?? tokenSession.length > 32) {
        return <MonitorSubscription location={loc} />;
      }
      return <NotAuthorized />;
    }
    case "clientDetail": {
      const tokenSession = window.localStorage.getItem("token");
      if (!!tokenSession && tokenSession.length > 32) {
        return <ClientDetail location={loc} />;
      }
      return <NotAuthorized />;
    }
    case "productlist": {
      // extract token from session
      const tokenSession = window.localStorage.getItem("token");
      if (!!tokenSession ?? tokenSession.length > 32) {
        return <ProductList location={loc} />;
      }
      return <Navigate to="/" />;
    }
    case "productListV2": {
      // extract token from session
      const tokenSession = window.localStorage.getItem("token");
      if (!!tokenSession ?? tokenSession.length > 32) {
        return <ProductsListV2 location={loc} />;
      }
      return <Navigate to="/" />;
    }
    case "productListV3": {
      // extract token from session
      const tokenSession = window.localStorage.getItem("token");
      if (!!tokenSession ?? tokenSession.length > 32) {
        return <ProductsListV3 location={loc} />;
      }
      return <Navigate to="/" />;
    }
    case "DetailsProductV3": {
      // extract token from session
      const tokenSession = window.localStorage.getItem("token");
      if (!!tokenSession ?? tokenSession.length > 32) {
        return <DetailProductV3 location={loc} />;
      }
      return <Navigate to="/" />;
    }
    case "detailsProductV2Nexbot": {
      // extract token from session
      const tokenSession = window.localStorage.getItem("token");
      if (!!tokenSession ?? tokenSession.length > 32) {
        return <DetailsProductV2Nexbot location={loc} />;
      }
      return <Navigate to="/" />;
    }
    case "detailsProductV2Nexcode": {
      // extract token from session
      const tokenSession = window.localStorage.getItem("token");
      if (!!tokenSession ?? tokenSession.length > 32) {
        return <DetailsProductsV2Nexcode location={loc} />;
      }
      return <Navigate to="/" />;
    }
    case "upgradeTier": {
      return <UpgradeTierPage location={loc} />;
    }
    // TEST CHECKOUT
    case "checkoutPage": {
      // extract token from session
      const tokenSession = window.localStorage.getItem("token");
      if (!!tokenSession ?? tokenSession.length > 32) {
        return <CheckoutPage location={loc} />;
      }
      return <Navigate to="/" />;
    }
    case "successPage": {
      // extract token from session
      const tokenSession = window.localStorage.getItem("token");
      if (!!tokenSession ?? tokenSession.length > 32) {
        return <SuccessPage location={loc} />;
      }
      return <Navigate to="/" />;
    }
    case "cancelPage": {
      // extract token from session
      const tokenSession = window.localStorage.getItem("token");
      if (!!tokenSession ?? tokenSession.length > 32) {
        return <CancelPage location={loc} />;
      }
      return <Navigate to="/" />;
    }
    //
    case "dashboard": {
      // extract token from session
      const tokenSession = window.localStorage.getItem("token");
      if (!!tokenSession ?? tokenSession.length > 32) {
        return <Dashboard location={loc} />;
      }
      return <Navigate to="/" />;
    }

    case "modal": {
      return <Modal location={loc} />;
    }
    case "mainContainer": {
      // extract token from session
      const tokenSession = window.localStorage.getItem("token");
      if (!!tokenSession ?? tokenSession.length > 32) {
        return <MainContainer location={loc} />;
      }
      return <Navigate to="/" />;
    }
    default: {
      return <Signin location={loc} />;
    }
  }
};

const App = () => {
  // catch all errors of the application and ....
  const dispatch = useDispatch();
  const products = useSelector((state) => state.productReducer?.productList?.products);

  try {
    window.onerror = (msg, url, lineNo, columnNo, error) => {
      // ... send they to errorHandler for logging
      setError(`*** CUSTOM ERROR **** ${msg} ${url}`);
      return true;
    };
  } catch (e) {
    // console.log("Some Errors: ", e);
  }

  useEffect(() => {
    dispatch(getProductListRequest());
    // get uid from session storage
    const uid = window.localStorage.getItem("uid") ?? "";

    // send uid to track user
    setUser({ uid });
  }, [dispatch]);

  return (
    <div className="App" data-test="appComponent">
      <BrowserRouter>
        <Routes>
          <Route
            path="/private/client-detail/"
            element={<WrapperComponent componentName="clientDetail" />}
          />
          <Route
            path="/tenant/user/password/:docId"
            element={<WrapperComponent componentName="activationWrapper" />}
          />
          <Route
            path="/private/signup/"
            element={<WrapperComponent componentName="signup" productList={products} />}
          />
          <Route
            path="/signupUser/"
            element={<WrapperComponent componentName="signupUser" />}
          />
          <Route
            path="/accountRecovery"
            element={<WrapperComponent componentName="accountRecovery" />}
          />
          <Route
            path="/signin/"
            element={<WrapperComponent componentName="signin" />}
          />
          <Route
            path="/private/createproduct/"
            element={<WrapperComponent componentName="createproduct" />}
          />
          <Route
            path="/private/contactPage/"
            element={<WrapperComponent componentName="contactPage" />}
          />
          <Route
            path="/"
            element={<WrapperComponent componentName="signin" productList={products} />}
          />
          <Route
            path="/private/detailstenant/"
            element={
              <WrapperComponent componentName="multidetailstenant" productList={products} />
            }
          />
          <Route
            path="/private/multidetailstenant/"
            element={
              <WrapperComponent componentName="multidetailstenant" productList={products} />
            }
          />
          <Route
            path="/private/userProfile/"
            element={
              <WrapperComponent componentName="userProfile" productList={products} />
            }
          />
          <Route
            path="/private/tenantlist/"
            element={
              <WrapperComponent componentName="tenantlist" productList={products} />
            }
          />
          <Route
            path="/private/userlist/"
            element={
              <WrapperComponent componentName="userlist" productList={products} />
            }
          />
          <Route
            path="/private/admin-monitoring/"
            element={
              <WrapperComponent componentName="admin-monitoring" />
            }
          />
          <Route
            path="/private/monitorSubscription/"
            element={
              <WrapperComponent componentName="monitorSubscription" />
            }
          />
          <Route
            path="/private/productlist/"
            element={<WrapperComponent componentName="productlist" />}
          />
          <Route
            path="/private/productListV2/"
            element={<WrapperComponent componentName="productListV2" />}
          />
          <Route
            path="/private/productListV3/"
            element={<WrapperComponent componentName="productListV3" />}
          />
          <Route
            path="/private/productListV3/:appCode"
            element={<WrapperComponent componentName="DetailsProductV3" />}
          />
          <Route
            path="/detailsProductV2Nexbot"
            element={<WrapperComponent componentName="detailsProductV2Nexbot" />}
          />
          <Route
            path="/detailsProductV2Nexcode"
            element={<WrapperComponent componentName="detailsProductV2Nexcode" />}
          />
          <Route
            path="/private/upgradeTier"
            element={<WrapperComponent componentName="upgradeTier" />}
          />
          {/* TEST CHECKOUT PAGE */}
          <Route
            path="/private/checkoutPage/:productId"
            element={<WrapperComponent componentName="checkoutPage" />}
          />
          {/* FINE TEST CHECKOUT PAGE */}
          <Route
            path="/private/dashboard"
            element={<WrapperComponent componentName="dashboard" />}
          />
          <Route
            path="private/modal/"
            element={<WrapperComponent componentName="modal" />}
          />
          <Route
            path="/flowbiteExample/"
            element={<WrapperComponent componentName="mainContainer" />}
          />
          <Route
            path="/private/checkoutPage/success"
            element={<WrapperComponent componentName="successPage" />}
          />
          <Route
            path="/private/checkoutPage/cancel"
            element={<WrapperComponent componentName="cancelPage" />}
          />
          <Route
            path="/detailProduct/:appCode"
            element={<DetailProduct />}
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default App;
